var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "el-container direction" }, [
    _vm.$route.query && _vm.$route.query.type === "file"
      ? _c(
          "div",
          { staticClass: "item" },
          [
            _c("fileUpload", {
              attrs: { folder: "files" },
              model: {
                value: _vm.val,
                callback: function ($$v) {
                  _vm.val = $$v
                },
                expression: "val",
              },
            }),
            _c("div", [
              _vm._v("上传文件地址： " + _vm._s(_vm.val ? _vm.val : "...")),
            ]),
          ],
          1
        )
      : _vm._e(),
    _vm.$route.query && _vm.$route.query.type === "lang"
      ? _c(
          "div",
          { staticClass: "item" },
          [
            _c(
              "el-button",
              {
                attrs: { loading: _vm.update },
                on: { click: _vm.handleUpdate },
              },
              [_vm._v("手动更新语言包")]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }